import { Button, styled, Theme } from '@material-ui/core';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { getCompletionColor } from 'pages/Representatives/utils/getCompletionColor';
import { CircularProgressbar } from 'react-circular-progressbar';
import { COLORS } from 'shared/constants/COLORS';
import { Link } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';

const {
  DARK_BUTTON_BACKGROUND,
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_TEXT,
  DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  OFFWHITE_BUTTON_BACKGROUND,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
  WARNING_BUTTON_BACKGROUND,
} = COLORS;

export const RepresentativesListItemContainer = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  border: `1px solid ${
    theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING
  }`,

  borderRadius: '8px',
  padding: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
    textDecoration: 'none',
  },
  // this margin top 20 is for the primary tag space, dont remove it
}));

export const RepresentativesListItemAvatarContainer = styled('div')(({ theme }) => ({
  backgroundColor: 'transparent',
  borderRadius: '8px',
  aspectRatio: '95/132',
  width: 'auto',
  height: 90,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    height: 100,
  },
  [theme.breakpoints.up('md')]: {
    height: 120,
  },
}));

export const RepresentativesListItemAvatar = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: '4px',
  objectFit: 'cover',
}));

export const RepresentativesListItemDetailsContainer = styled('div')(({ theme }) => ({
  widht: '100%',
  overflow: 'hidden',
  flex: 1,
}));

export const RepresentativesListItemPrimaryTagContainer = styled(Button)(
  ({ theme, primary }: { theme: Theme; primary: boolean }) => ({
    position: 'absolute',
    top: -21,
    borderRadius: 0,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    height: 20,
    width: 130,
    padding: 1,
    textAlign: 'center',
    backgroundColor: primary
      ? PRIMARY_BUTTON_BACKGROUND
      : theme.palette.type === 'dark'
        ? DARK_BUTTON_BACKGROUND
        : OFFWHITE_BUTTON_BACKGROUND,
    cursor: 'pointer',
    color: primary ? PLAIN_TEXT : theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
    transition: '0.2s',
    '&:hover': {
      backgroundColor: primary ? undefined : PRIMARY_BUTTON_BACKGROUND,
      color: PLAIN_TEXT,
    },
  }),
);

export const RepresentativesListItemPrimaryTagText = styled(TypographyTooltip)(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: '13px !important',
  fontWeight: 500,
  color: 'inherit',
}));

export const RepresentativesListItemProgressBarContainer = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  color: 'white',
  display: 'flex',
}));

export const RepresentativesListItemProgressBar = styled(CircularProgressbar)(
  ({ theme, completeness = 0 }: { theme: Theme; completeness: number }) => ({
    overflow: 'hidden',
    color: 'white',
    display: 'flex',
    maxWidth: 25,

    [theme.breakpoints.up('sm')]: {
      maxWidth: 30,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 40,
    },

    '& .CircularProgressbar-path': {
      stroke: getCompletionColor(completeness) + '!important',
    },

    '& .CircularProgressbar-text': {
      fill: (theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT) + '!important',
    },
    '& .CircularProgressbar-trail': {
      stroke:
        (theme.palette.type === 'dark' ? DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND : GRAY_CIRCULAR_PROGRESS_BACKGROUND) +
        '!important',
    },
  }),
);

export const RepresentativesListItemPrivateText = styled('p')({
  textTransform: 'uppercase',
  fontSize: '14px',
  fontWeight: 500,
  color: PLAIN_TEXT,
  backgroundColor: WARNING_BUTTON_BACKGROUND,
  padding: '1px 5px',
  maxWidth: 'fit-content',
  borderRadius: 4,
});
